import { useState, useCallback } from 'react';
import type { LeadData } from '@/types/chat';
import { 
  collection, 
  addDoc, 
  getDocs, 
  query, 
  orderBy, 
  writeBatch, 
  doc 
} from 'firebase/firestore';
import { db } from '@/lib/firebase';

export function useLeads() {
  const [leads, setLeads] = useState<LeadData[]>([]);

  // Carrega os leads do Firestore (Alterado para ler de 'chats')
  const loadLeads = useCallback(async () => {
    try {
      const q = query(collection(db, 'chats'), orderBy('createdAt', 'desc'));
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((d) => ({ ...d.data(), id: d.id } as LeadData));
      setLeads(data);
    } catch (error) {
      console.error('Erro ao carregar leads:', error);
    }
  }, []);

  // Adiciona um novo lead (Alterado para salvar em 'chats')
  const addLead = useCallback(async (lead: Omit<LeadData, 'id' | 'createdAt'>) => {
    try {
      const newLeadData = {
        ...lead,
        createdAt: new Date().toISOString(),
      };

      const docRef = await addDoc(collection(db, 'chats'), newLeadData);
      const newLead = { ...newLeadData, id: docRef.id } as LeadData;

      setLeads((prev) => [newLead, ...prev]);
      return newLead;
    } catch (error) {
      console.error('Erro ao salvar lead:', error);
      throw error;
    }
  }, []);

  // Limpa os dados (Alterado para deletar de 'chats')
  const clearLeads = useCallback(async () => {
    try {
      const snapshot = await getDocs(collection(db, 'chats'));
      
      if (snapshot.empty) {
        setLeads([]);
        return;
      }

      // Uso de Batch para deletar tudo em uma única requisição (mais rápido)
      const batch = writeBatch(db);
      snapshot.docs.forEach((d) => {
        batch.delete(doc(db, 'chats', d.id));
      });

      await batch.commit();
      setLeads([]);
      
      console.log('Todos os leads foram removidos do banco de dados.');
    } catch (error) {
      console.error('Erro ao limpar leads do banco:', error);
      alert('Erro ao excluir dados do servidor.');
    }
  }, []);

  return { leads, addLead, clearLeads, loadLeads };
}